import React, { useState, useEffect } from 'react';
import ProfileCard from './components/ProfileCard';
import ProfileDetails from './components/ProfileDetails';
import { useAuth } from '@/contexts/AuthContext';
import authService from '@/services/authService';
import { FullScreenLoader } from '@/components/ui/loader';

const ProfilePage = () => {
  const { userProfile } = useAuth();
  const [profileData, setProfileData] = useState({
    name: '',
    email: '',
    phone: '',
    role: '',
    joinDate: '',
    location: '',
    companyName: '',
    registrationNumber: '',
    contactPerson: '',
    address: ''
  });
  const [loading, setLoading] = useState(true);

  const formatRoleDisplay = (profile) => {
    if (!profile) return '';
    if (profile.role_display) return profile.role_display;
    const role = profile.role || '';
    const clean = role.toLowerCase();
    if (clean === 'field_officer') return 'Field Officer';
    if (clean === 'account_head') return 'Account Head';
    if (clean === 'region_head') return 'Region Head';
    if (clean === 'ipl_admin') return 'IPL Admin';
    return role
      .replace('ipl_', '')
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        setLoading(true);
        
    
        const latestProfile = await authService.getCurrentUser();
        
        if (latestProfile) {
          setProfileData({
            name: latestProfile.username || userProfile?.username || '',
            email: latestProfile.email || userProfile?.email || '',
            phone: latestProfile.phone_number || userProfile?.phone_number || '',
            role: formatRoleDisplay(latestProfile) || formatRoleDisplay(userProfile) || '',
            joinDate: latestProfile.created_at ? new Date(latestProfile.created_at).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
            location: '',
            companyName: latestProfile.company_name || userProfile?.company_name || '',
            registrationNumber: latestProfile.registration_number || userProfile?.registration_number || '',
            contactPerson: latestProfile.contact_person || userProfile?.contact_person || '',
            address: latestProfile.address || userProfile?.address || ''
          });
        } else if (userProfile) {
          setProfileData({
            name: userProfile.username || '',
            email: userProfile.email || '',
            phone: userProfile.phone_number || '',
            role: formatRoleDisplay(userProfile) || '',
            joinDate: userProfile.created_at ? new Date(userProfile.created_at).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
            location: '',
            companyName: userProfile.company_name || '',
            registrationNumber: userProfile.registration_number || '',
            contactPerson: userProfile.contact_person || '',
            address: userProfile.address || ''
          });
        }
      } catch (error) {
        console.error('Failed to fetch profile data:', error);
 
        if (userProfile) {
          setProfileData({
            name: userProfile.username || '',
            email: userProfile.email || '',
            phone: userProfile.phone_number || '',
            role: formatRoleDisplay(userProfile) || '',
            joinDate: userProfile.created_at ? new Date(userProfile.created_at).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
            location: '',
            companyName: userProfile.company_name || '',
            registrationNumber: userProfile.registration_number || '',
            contactPerson: userProfile.contact_person || '',
            address: userProfile.address || ''
          });
        }
      } finally {
        setLoading(false);
      }
    };

    if (userProfile) {
      fetchProfileData();
    } else {
      setLoading(false);
    }
  }, [userProfile]);

  if (loading) {
    return <FullScreenLoader isLoading={loading} />;
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-1">
          <ProfileCard profileData={profileData} />
        </div>

        <div className="lg:col-span-2">
          <ProfileDetails
            profileData={profileData}
          />
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;